import core from '../modules/core';
import store from '@/store/store'
import utils from '@/utils/utils'

export default {
  getDgnstTstngCpnInfo(parameters={}) {
    return core.call({
      url: '/api/v1/mycstmr/getDgnstTstngCpnInfo',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }    
    }); 
  },
}
